import { createFileRoute } from '@tanstack/react-router';
import StaysManagement from '../../components/manager/StaysManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/stays')({
  component: StaysManagementRoute,
});

function StaysManagementRoute() {
  return (
    <ManagerPortal>
      <StaysManagement />
    </ManagerPortal>
  );
}
